<template>
  <v-form v-if="agreement" ref="form" v-model="valid" lazy-validation @submit.prevent="onSubmit">
    <v-row justify="center">
      <v-col md="8" lg="6">
        <div v-if="$vuetify.breakpoint.smAndDown" class="title mb-6">
          {{ $t('message.choose_your_connection_speed') }}
        </div>

        <v-row justify="end" align="center" no-gutters>
          {{ $t('message.sort_by') }}
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn depressed small class="ma-2" v-on="on">
                {{
                  'netPrice' === visibleAirtimePlansSort.sortBy
                    ? $t('message.price')
                    : 'downloadMir' === visibleAirtimePlansSort.sortBy
                    ? $t('message.speed')
                    : $t('message.monthly_volume')
                }}
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="visibleAirtimePlansSort.sortBy = 'netPrice'">
                <v-list-item-title>
                  {{ $t('message.price') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="showOrderBySpeed" @click="visibleAirtimePlansSort.sortBy = 'downloadMir'">
                <v-list-item-title>
                  {{ $t('message.speed') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="showOrderByVolume" @click="visibleAirtimePlansSort.sortBy = 'monthlyVolume'">
                <v-list-item-title>
                  {{ $t('message.monthly_volume') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn
            style="min-width: 0"
            small
            depressed
            class="my-2"
            @click="visibleAirtimePlansSort.descending = !visibleAirtimePlansSort.descending"
          >
            <v-icon v-if="visibleAirtimePlansSort.descending" size="16">mdi-sort-ascending</v-icon>
            <v-icon v-else size="16">mdi-sort-descending</v-icon>
          </v-btn>
        </v-row>

        <v-row v-if="true === isLoading" no-gutters justify="center">
          <v-progress-circular color="primary" indeterminate></v-progress-circular>
        </v-row>
        <div :key="pricesKey" class="mt-3">
          <v-radio-group
            :key="visibleAirtimePlansSort.descending + visibleAirtimePlansSort.sortBy"
            v-model="selectedAirtimePlan"
            class="radio-group-full-width"
          >
            <template v-for="(airtimePlan, index) in visibleAirtimePlans">
              <template
                v-if="
                  'undefined' !== typeof airtimePlan.defaultPrice &&
                    null !== airtimePlan.defaultPrice &&
                    Object.keys(airtimePlan.defaultPrice).length !== 0
                "
              >
                <v-row
                  :key="airtimePlan.id"
                  class="airtime-selector pa-3 fill-height"
                  :class="{
                    'blue lighten-5': airtimePlan === selectedAirtimePlan
                  }"
                  align="center"
                  justify="start"
                  @click="selectedAirtimePlan = airtimePlan"
                >
                  <v-row no-gutters align="center" justify="start">
                    <v-col class="shrink">
                      <v-radio :value="airtimePlan"></v-radio>
                    </v-col>
                    <v-col class="grow">
                      <v-row>
                        <v-col class="grow">
                          <div class="subheading">
                            {{ airtimePlan.name }}
                          </div>
                          <div v-if="airtimePlan.monthlyVolume" class="title">
                            {{ airtimePlan.monthlyVolume }} GB/{{ $t('message.month').toLowerCase() }}
                          </div>
                          <div v-if="airtimePlan.downloadMir && airtimePlan.uploadMir" class="title">
                            {{ formatSpeed(airtimePlan.downloadMir) }}
                            /
                            {{ formatSpeed(airtimePlan.uploadMir) }}
                          </div>

                          <div v-if="airtimePlan.downloadCir && airtimePlan.uploadCir" class="grey--text mt-1 caption">
                            CIR:
                            {{ formatSpeed(airtimePlan.downloadCir) }}
                            /
                            {{ formatSpeed(airtimePlan.uploadCir) }}
                          </div>
                        </v-col>
                        <v-col
                          class="shrink"
                          :class="{ 'text-right': $vuetify.breakpoint.smAndUp, 'pt-0': $vuetify.breakpoint.xsOnly }"
                          :cols="$vuetify.breakpoint.smAndUp ? 'auto' : 12"
                        >
                          <template v-if="0 === airtimePlan.defaultPrice.feesCount">
                            <div class="headline mr-3">
                              {{ $n(airtimePlan.defaultPrice.initialCharge.netPrice, agreement.currency.code) }}
                            </div>
                            <div class="caption grey--text  mr-3">
                              {{ $n(airtimePlan.defaultPrice.initialCharge.grossPrice, agreement.currency.code) }}
                              ({{
                                $t('message.tax_incl', {
                                  tax: airtimePlan.defaultPrice.initialCharge.tax
                                })
                              }})
                            </div>
                          </template>
                          <template v-else>
                            <div class="headline mr-3">
                              {{ $n(airtimePlan.defaultPrice.monthlyFee.netPrice, agreement.currency.code) }}/{{
                                $t('message.month').toLowerCase()
                              }}
                            </div>
                            <div class="caption grey--text  mr-3">
                              {{ $n(airtimePlan.defaultPrice.monthlyFee.grossPrice, agreement.currency.code) }}/{{
                                $t('message.month').toLowerCase()
                              }}
                              ({{
                                $t('message.tax_incl', {
                                  tax: airtimePlan.defaultPrice.monthlyFee.tax
                                })
                              }})
                            </div>
                          </template>
                          <div v-if="airtimePlan.balance && !isBalanceExceeded(airtimePlan.balance)">
                            <v-chip
                              class="mt-2"
                              :class="{ 'ma-2': $vuetify.breakpoint.smAndUp }"
                              color="blue lighten-5"
                              small
                              text-color="grey darken-1"
                            >
                              <v-icon left size="18">mdi-wallet</v-icon>
                              {{
                                $t('message.days_of_available_balance', {
                                  remainingDays: airtimePlan.balance.remainingDays
                                })
                              }}
                            </v-chip>
                          </div>
                          <div>
                            <v-btn
                              v-if="
                                ($i18n.locale === 'en' && airtimePlan.pricingDescription) ||
                                  ($i18n.locale === 'es' && airtimePlan.pricingDescriptionEs)
                              "
                              small
                              color="primary"
                              text
                              @click.stop="showPricingDescription(airtimePlan)"
                              >{{ $t('message.price_info') }}</v-btn
                            >
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-row>

                <v-row v-if="selectedAirtimePlan === airtimePlan" :key="'continue-' + index" justify="end" no-gutters>
                  <v-btn
                    v-if="selectedAirtimePlan"
                    :disabled="true === isLoading"
                    class="mr-0 mb-3 ml-0 mt-3"
                    color="primary"
                    type="submit"
                    >{{ $t('message.continue') }}</v-btn
                  >
                </v-row>

                <v-divider v-if="index < agreement.visibleAirtimePlans.length - 1" :key="index" />
              </template>
            </template>
          </v-radio-group>
        </div>

        <div class="grey--text caption text-right mb-3">
          {{ $t('message.speed_info') }}
        </div>

        <v-row justify="center">
          <v-btn class="ma-3" @click="$emit('updateStep', 1)">{{ $t('message.back') }}</v-btn>
          <v-btn :disabled="!selectedAirtimePlan || true === isLoading" color="primary" type="submit" class="ma-3">{{
            $t('message.continue')
          }}</v-btn>
        </v-row>
      </v-col>
    </v-row>

    <v-dialog v-model="pricingDescriptionDialog" max-width="400">
      <v-card v-if="pricingDescriptionAirtimePlan">
        <v-card-title>
          <div>
            <div class="headline">{{ pricingDescriptionAirtimePlan.name }}</div>
            <div v-if="pricingDescriptionAirtimePlan.monthlyVolume" class="subheading">
              {{ pricingDescriptionAirtimePlan.monthlyVolume }} GB/{{ $t('message.month').toLowerCase() }}
            </div>
            <div
              v-if="pricingDescriptionAirtimePlan.downloadMir && pricingDescriptionAirtimePlan.uploadMir"
              class="subheading"
            >
              {{ formatSpeed(pricingDescriptionAirtimePlan.downloadMir) }}
              /
              {{ formatSpeed(pricingDescriptionAirtimePlan.uploadMir) }}
            </div>
            <div
              v-if="pricingDescriptionAirtimePlan.downloadCir && pricingDescriptionAirtimePlan.uploadCir"
              class="grey--text text--darken-2 caption"
            >
              CIR:
              {{ formatSpeed(pricingDescriptionAirtimePlan.downloadCir) }}
              /
              {{ formatSpeed(pricingDescriptionAirtimePlan.uploadCir) }}
            </div>
          </div>
        </v-card-title>

        <v-card-text>
          <!-- prettier-ignore -->
          <p style="white-space: pre-line;">
            <template v-if="'es' === $i18n.locale">
              {{ pricingDescriptionAirtimePlan.pricingDescriptionEs }}
            </template>
            <template v-else>
              {{ pricingDescriptionAirtimePlan.pricingDescription }}
            </template>
          </p>

          <span class="grey--text caption">
            {{ $t('message.all_prices_are_shown_without_vat') }}
            <br />
            {{ $t('message.speed_info') }}
          </span>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="pricingDescriptionDialog = false">{{ $t('message.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>
<script>
import fetch from '@/utils/fetch'

export default {
  name: 'ConnectionSpeed',

  props: {
    agreement: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    airtimeBalancesMerged: {
      type: Array,
      required: false,
      default: null
    }
  },

  data() {
    return {
      visibleAirtimePlans: [],
      visibleAirtimePlansSort: { sortBy: 'netPrice', descending: false },
      pricesKey: null,
      selectedAirtimePlan: null,
      valid: true,
      pricingDescriptionDialog: false,
      pricingDescriptionAirtimePlan: null,
      showOrderBySpeed: false,
      showOrderByVolume: false,
      isLoading: false
    }
  },

  watch: {
    visibleAirtimePlans(visibleAirtimePlans) {
      visibleAirtimePlans.forEach(visibleAirtimePlan => {
        if (visibleAirtimePlan.monthlyVolume !== null) {
          this.showOrderByVolume = true
        }
        if (visibleAirtimePlan.downloadMir != null) {
          this.showOrderBySpeed = true
        }
      })
    },
    visibleAirtimePlansSort: {
      handler: function() {
        this.sortAllowedAirtimePlans()
      },
      deep: true
    }
  },

  created() {
    this.fetchDefaultPrices()
    if (this.item.airtimePlan) {
      this.selectedAirtimePlan = this.item.airtimePlan
    }
  },

  methods: {
    fetchDefaultPrices() {
      if (this.agreement && this.item.startsAt && this.item.endsAt) {
        const startsAt = this.$moment(this.item.startsAt)
          .tz('Europe/Madrid')
          .set({ hour: 8, minutes: 0, second: 0, millisecond: 0 })
          .format('YYYY-MM-DD HH:mm:ss')
        const endsAt = this.$moment(this.item.endsAt)
          .tz('Europe/Madrid')
          .set({ hour: 8, minutes: 0, second: 0, millisecond: 0 })
          .format('YYYY-MM-DD HH:mm:ss')
        const agreementId = this.agreement.id

        const headers = new Headers({
          Accept: 'application/json',
          'Content-Type': 'application/json'
        })

        this.visibleAirtimePlans = []
        this.isLoading = true
        let loadedCount = 0
        this.agreement.visibleAirtimePlans.forEach(airtimePlan => {
          airtimePlan.balance = this.airtimeBalancesMerged.filter(balance => {
            return balance.airtimePlan['@id'] === airtimePlan['@id']
          })[0]

          airtimePlan.defaultPrice = null
          let url =
            airtimePlan['@id'] +
            '/default_price?startsAt=' +
            startsAt +
            '&endsAt=' +
            endsAt +
            '&agreement=' +
            agreementId
          fetch(url, { headers: headers })
            .then(response => {
              return response.json()
            })
            .then(data => {
              let visibleAirtimePlan = airtimePlan
              visibleAirtimePlan.defaultPrice = data

              if (!this.visibleAirtimePlans.includes(visibleAirtimePlan)) {
                this.visibleAirtimePlans.push(visibleAirtimePlan)
                loadedCount++

                if (loadedCount >= this.agreement.visibleAirtimePlans.length) {
                  this.isLoading = false
                }
              }
              this.sortAllowedAirtimePlans()

              this.pricesKey = new Date().getTime()
            })
            .catch(e => {
              // eslint-disable-next-line no-console
              console.log(e)
              this.pricesKey = new Date().getTime()
            })
        })
      }
    },

    sortAllowedAirtimePlans() {
      if (this.visibleAirtimePlans.length === 0) {
        return []
      }

      this.visibleAirtimePlans = this.visibleAirtimePlans.sort((a, b) => {
        if ('netPrice' === this.visibleAirtimePlansSort.sortBy) {
          if (!a.defaultPrice) {
            return -1
          }

          if (!b.defaultPrice) {
            return 1
          }

          if (a.defaultPrice.total.netPrice < b.defaultPrice.total.netPrice) {
            return this.visibleAirtimePlansSort.descending ? 1 : -1
          } else if (a.defaultPrice.total.netPrice > b.defaultPrice.total.netPrice) {
            return this.visibleAirtimePlansSort.descending ? -1 : 1
          } else {
            return 0
          }
        }

        if ('downloadMir' === this.visibleAirtimePlansSort.sortBy) {
          if (!a.downloadMir) {
            return -1
          }

          if (!b.downloadMir) {
            return 1
          }

          if (a.downloadMir < b.downloadMir) {
            return this.visibleAirtimePlansSort.descending ? 1 : -1
          } else if (a.downloadMir > b.downloadMir) {
            return this.visibleAirtimePlansSort.descending ? -1 : 1
          } else {
            if (a.downloadCir < b.downloadCir) {
              return this.visibleAirtimePlansSort.descending ? 1 : -1
            } else if (a.downloadCir > b.downloadCir) {
              return this.visibleAirtimePlansSort.descending ? -1 : 1
            } else {
              return 0
            }
          }
        }

        if ('monthlyVolume' === this.visibleAirtimePlansSort.sortBy) {
          if (!a.monthlyVolume) {
            return -1
          }

          if (!b.monthlyVolume) {
            return 1
          }

          if (a.monthlyVolume < b.monthlyVolume) {
            return this.visibleAirtimePlansSort.descending ? 1 : -1
          } else if (a.monthlyVolume > b.monthlyVolume) {
            return this.visibleAirtimePlansSort.descending ? -1 : 1
          } else {
            return 0
          }
        }
      })
    },

    formatSpeed(value) {
      if (value >= 1024) {
        return this.$n(value / 1024) + ' Mbps'
      }

      return this.$n(value) + ' kbps'
    },

    isBalanceExceeded(airtimeBalance) {
      if (!airtimeBalance) {
        return true
      }
      return (
        this.$moment(this.item.endsAt)
          .subtract(1, 'days')
          .diff(this.$moment(this.item.startsAt), 'days') >= airtimeBalance.remainingDays
      )
    },

    showPricingDescription(airtimePlan) {
      this.pricingDescriptionAirtimePlan = airtimePlan
      this.pricingDescriptionDialog = true
    },

    onSubmit() {
      let item = this.item
      item.airtimePlan = this.selectedAirtimePlan
      this.$emit('updateItem', item)
      this.$emit('updateStep', 3)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .radio-group-full-width .v-input__control {
  width: 100%;
}

.airtime-selector {
  cursor: pointer;

  &:hover {
    background-color: #fafafa;
  }
}
</style>
